export default __webpack_public_path__ + "static/media/detail_mobile_13_7.e672ecc1.jpg";